import { View } from "@src/components";
import { FC, memo } from "react";
import { StyleSheet } from "react-native-unistyles";

type PinDotsProps = {
  pinLength: number;
  totalDots?: number;
};

const DotSize = 24;

export const PinDots: FC<PinDotsProps> = memo(({ pinLength, totalDots = 4 }) => {
  return (
    <View flexDirection="row" gap="xl">
      {Array.from({ length: totalDots }).map((_, index) => (
        <View key={index} style={[styles.pinDot, index < pinLength && styles.pinDotFilled]} />
      ))}
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  pinDot: {
    width: DotSize,
    height: DotSize,
    borderRadius: theme.spacing.sm,
    borderWidth: 1.5,
    borderColor: theme.colors.surface1.foregroundSecondary,
    borderCurve: "continuous",
  },
  pinDotFilled: {
    backgroundColor: theme.colors.interactive.controls.secondary_background,
    borderColor: theme.colors.interactive.controls.selected_midground,
  },
}));
